import { FC } from 'react';
//import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import { PrismLight } from 'react-syntax-highlighter';
import markup from 'react-syntax-highlighter/dist/esm/languages/prism/markup';
import { materialDark as SyntaxStyle } from 'react-syntax-highlighter/dist/esm/styles/prism';

import log from '~services/log';
// temp solution for react 19
const SyntaxHighlighter = PrismLight as any;

// register syntax highlighting for HTML code (html = markup)
SyntaxHighlighter.registerLanguage('markup', markup);

export interface ICodeBlockProps {
  code: string;
}

const CodeBlock: FC<ICodeBlockProps> = ({ code }) => {
  if (typeof code !== 'string') {
    log(`Provided invalid 'code' to CodeBlock. Expected 'string' but received '${typeof code}'`, code, 'warning');
    return null;
  }

  return (
    <>
      <SyntaxHighlighter language="markup" style={SyntaxStyle}>
        {code}
      </SyntaxHighlighter>
    </>
  );
};

export default CodeBlock;
